<template>
  <div class="bc__ui__list">
      <ol>
          <li v-for="(item, i) in this.list" :key="i">
              <span :class="'bg--' + item.logo_name"></span>
              <p>{{ trans('common::crop.'+item.name+'') }}</p>
              <data :value="item.count">x{{item.count}}</data>
          </li>
      </ol>
  </div>
</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'list'
        ],

    }

</script>